export type NavLinkItem = {
  pathname: string;
  label: string;
  external?: boolean;
};

export type NavItem = NavLinkItem | {
  label: string;
  children: NavLinkItem[];
};

export type LanguageOption = {
  code: string;
  name: string;
};

export type PartnerLogo = {
  src: string;
  alt: string;
};

export const navItems: NavItem[] = [
  { pathname: "/", label: "laboratorio" },
  { pathname: "/ourTeam", label: "grupo" },
  {
    label: "publicaciones",
    children: [
      { pathname: "/publications", label: "articulos" },
      { pathname: "/researchLines", label: "lineas" },
    ],
  },
  { pathname: "/contactUs", label: "contacto" },
  { pathname: "/events", label: "eventos" },
  {
    label: "mayan_on_chip",
    children: [
      { pathname: "/mayanOnChip", label: "mayan_information" },
      {
        pathname: "https://mayanonchip.industria4fiuady.com/login/index.php",
        label: "mayan_platform_access",
        external: true,
      },
    ],
  },
];

export const languageOptions: LanguageOption[] = [
  { code: "ES", name: "ES" },
  { code: "EN", name: "EN" },
  { code: "FR", name: "FR" },
];